import * as XLSX from 'xlsx-js-style';
import { ExcelOptions, ExcelTemplate } from '../../interfaces';
import { setColumnWidth, withHeaderStyling } from '../../utils';
import { RoundsComparison } from 'src/app/domain/portfolio-comparison/dto/RoundsComparison';
import { getPreparedData } from './mapping';
export class RoundComparisonTemplate implements ExcelTemplate {
  export(data: RoundsComparisonExportExcelDTO, options: ExcelOptions): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData: RoundsComparisonExportExcelDTO): XLSX.WorkSheet {
    const firstPeriod = exportExcelData.firstPeriod;
    const secondPeriod = exportExcelData.secondPeriod;
    const preparedData = getPreparedData(exportExcelData, this.getHeadersForLogic(),
      this.getHeadersForDisplay(), this.getFirstRow(firstPeriod, secondPeriod));
    const whiteSpaceIndexes = [1, 8, 15];

    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    const columnNumber = this.getHeadersForDisplay().length;
    for (let i = 0; i < columnNumber; i++) {
      // setting column width 12 for all columns except first
      setColumnWidth(sheet, i, i === 0 ? 20 : 12);
    }
    // setting white spaces
    whiteSpaceIndexes.forEach((index) => setColumnWidth(sheet, index, 1.5));
    return withHeaderStyling(sheet);
  }

  private getHeadersForDisplay() {
    return [
      'Round Name', '',
      'Investment', 'Fair value', 'Gain/(loss)', 'Funds Shares', 'Valuated PPS', 'Holding', '',
      'Investment', 'Fair value', 'Gain/(loss)', 'Funds Shares', 'Valuated PPS', 'Holding', '',
      'Investment', 'Fair value', 'Gain/(loss)', 'Funds Shares', 'Valuated PPS', 'Holding',
    ];
  }

  private getHeadersForLogic() {
    return [
      'Round Name', null,
      'Investment(0)', 'Fair value(0)', 'Gain/(loss)(0)', 'Funds Shares(0)', 'Valuated PPS(0)', 'Holding(0)', null,
      'Investment(1)', 'Fair value(1)', 'Gain/(loss)(1)', 'Funds Shares(1)', 'Valuated PPS(1)', 'Holding(1)', null,
      'Investment(2)', 'Fair value(2)', 'Gain/(loss)(2)', 'Funds Shares(2)', 'Valuated PPS(2)', 'Holding(2)',
    ];
  }

  private getFirstRow(firstPeriod, secondPeriod) {
    const numberOfColumns = this.getHeadersForDisplay().length;
    const row = new Array(numberOfColumns).fill(``);

    row[2] = secondPeriod;
    row[9] = 'Difference';
    row[16] = firstPeriod;

    row.fill(null, 0, 2);
    row[8] = null;
    row[15] = null;

    return row;
  }
}

export interface RoundsComparisonExportExcelDTO {
  firstPeriod: Date;
  secondPeriod: Date;
  activeRounds: RoundsComparison[];
  soldRounds: RoundsComparison[];
  totalActive: RoundsComparison;
  totalSold: RoundsComparison;
}
